import api from './api';
import type { PaginatedResponse, Notification, Reminder } from '../types';

export const getNotifications = async (page = 1, limit = 10): Promise<PaginatedResponse<Notification>> => {
  const response = await api.get<PaginatedResponse<Notification>>('notifications', {
    params: { page, limit },
  });
  return response.data;
};

export const getNotificationCounts = async (): Promise<{ unread: number; total: number }> => {
  const response = await api.get('notifications/counts');
  return response.data.data;
};

export const markNotificationAsRead = async (id: string): Promise<Notification> => {
  const response = await api.post(`notifications/read/${id}`);
  return response.data.data;
};

export const getMyReminders = async (page = 1, limit = 10): Promise<PaginatedResponse<Reminder>> => {
  const response = await api.get<PaginatedResponse<Reminder>>('reminders/my', {
    params: { page, limit },
  });
  return response.data;
};
